import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class InternalError extends Error {
  constructor(status, code, message) {
    super(message);
    _defineProperty(this, "status", void 0);
    _defineProperty(this, "code", void 0);
    this.status = status;
    this.code = code;
    this.name = this.constructor.name;
    this.stack = new Error().stack;
  }
}
export const createToError = (parseInternalError, parseNativeError) => error => {
  error = error.response || error;
  return Promise.reject(error instanceof InternalError ? parseInternalError(error) : parseNativeError(error));
};
//# sourceMappingURL=internal-error.js.map